/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMicroAuthDetailsRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetMicroAuthDetails.pb'
import {GetMicroAuthDetailsResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetMicroAuthDetails.pb'


export const getMicroAuthDetails = (request: GetMicroAuthDetailsRequest, options?: CashRequestOptions) => post<GetMicroAuthDetailsRequest, GetMicroAuthDetailsResponse>("/2.0/cash/get-micro-auth-details", request, {...options, rejectOnError: true })